(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4894],{

/***/ 57711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _container_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20798);
/* harmony import */ var _container_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_container_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Container = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_container_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container), props.fullWidth && (_container_module_scss__WEBPACK_IMPORTED_MODULE_3___default().full_width), props.className),
        style: props.style,
        id: props.htmlId,
        ref: ref,
        children: props.children
    });
});
Container.defaultProps = {};


/***/ }),

/***/ 35622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ HeaderDashboard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/modules/layout/ui/header-dashboard/header-dashboard.module.scss
var header_dashboard_module = __webpack_require__(78593);
var header_dashboard_module_default = /*#__PURE__*/__webpack_require__.n(header_dashboard_module);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
// EXTERNAL MODULE: ./src/shared/ui/popover/popover.module.scss
var popover_module = __webpack_require__(55837);
var popover_module_default = /*#__PURE__*/__webpack_require__.n(popover_module);
// EXTERNAL MODULE: ./src/shared/ui/popover/menu/popover-menu.module.scss
var popover_menu_module = __webpack_require__(99040);
var popover_menu_module_default = /*#__PURE__*/__webpack_require__.n(popover_menu_module);
;// CONCATENATED MODULE: ./src/shared/ui/popover/menu/popover-menu.tsx




const PopoverMenu = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((popover_menu_module_default()).popover_menu, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
PopoverMenu.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/popover/item/popover-item.module.scss
var popover_item_module = __webpack_require__(13418);
var popover_item_module_default = /*#__PURE__*/__webpack_require__.n(popover_item_module);
;// CONCATENATED MODULE: ./src/shared/ui/popover/item/popover-item.tsx




const PopoverItem = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((popover_item_module_default()).popover_item, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
PopoverItem.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/popover/divider/popover-divider.module.scss
var popover_divider_module = __webpack_require__(67053);
var popover_divider_module_default = /*#__PURE__*/__webpack_require__.n(popover_divider_module);
;// CONCATENATED MODULE: ./src/shared/ui/popover/divider/popover-divider.tsx




const PopoverDivider = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((popover_divider_module_default()).popover_divider, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
PopoverDivider.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/lib/use-key-down.tsx
var use_key_down = __webpack_require__(55353);
;// CONCATENATED MODULE: ./src/shared/ui/popover/popover.tsx








const Popover = (props)=>{
    const [open, setOpen] = (0,react.useState)(false);
    const toggle = (0,react.useCallback)(()=>setOpen((open)=>!open), [
        setOpen
    ]);
    const close = (0,react.useCallback)(()=>setOpen(false), [
        setOpen
    ]);
    (0,use_key_down/* useKeyDown */.K)(use_key_down/* KeyName.ESC */.e.ESC, close);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((popover_module_default()).popover, open && (popover_module_default()).open, props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (popover_module_default()).trigger,
                onClick: toggle,
                children: props.trigger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((popover_module_default()).overlay),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (popover_module_default()).inner,
                    children: props.children
                })
            })
        ]
    });
};
Popover.Menu = PopoverMenu;
Popover.Item = PopoverItem;
Popover.Divider = PopoverDivider;
Popover.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/avatar/avatar.tsx
var avatar = __webpack_require__(57233);
// EXTERNAL MODULE: ./src/shared/ui/select/select.tsx
var select_select = __webpack_require__(14080);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/pages/_router.tsx
var _router = __webpack_require__(8254);
// EXTERNAL MODULE: ./src/modules/layout/model/theme.tsx
var model_theme = __webpack_require__(64346);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./src/shared/lib/use-api-method.ts
var use_api_method = __webpack_require__(24453);
// EXTERNAL MODULE: ./src/shared/ui/modal/modal.tsx + 7 modules
var modal = __webpack_require__(4629);
// EXTERNAL MODULE: ./src/shared/ui/input/input.tsx
var input = __webpack_require__(99088);
// EXTERNAL MODULE: ./src/shared/ui/error/error.tsx
var error = __webpack_require__(64871);
// EXTERNAL MODULE: ./src/shared/ui/loading-dots/loading-dots.tsx
var loading_dots = __webpack_require__(42966);
;// CONCATENATED MODULE: ./src/modules/company/features/company-create/company-create-modal.tsx







const CompanyCreateModal = (props)=>{
    const list = init/* api.company.useCompanyList */.h.company.useCompanyList();
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.company.companyCreate */.h.company.companyCreate);
    const [name, setName] = (0,react.useState)("");
    const onSubmit = async (e)=>{
        e.preventDefault();
        if (!name) return;
        if (name.length < 5) {
            submit.setError({
                type: "manual",
                message: "Слишком короткое имя компании, нужно 5 символов или больше"
            });
            return;
        }
        const resp = await submit.call({
            name,
            avatarImageId: null
        });
        await init/* api.financeSettings.financeSettingsUpdateEducation */.h.financeSettings.financeSettingsUpdateEducation(resp.slug, {
            education: true
        });
        await init/* api.financeSettings.financeSettingsUpdateEducationStep */.h.financeSettings.financeSettingsUpdateEducationStep(resp.slug, {
            educationStep: 0
        });
        await router_default().push(_router/* default.company */.Z.company(resp.slug).finances.education.href);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal */.u, {
        onClose: props.close,
        width: 400,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Header */.u.Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                        children: "Новая компания"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Body */.u.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                            autoFocus: true,
                            placeholder: "Название компании",
                            value: name,
                            onChange: (e)=>setName(e.target.value)
                        }),
                        submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                            style: {
                                marginTop: 24
                            },
                            children: submit.error.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Actions */.u.Actions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "button",
                            onClick: props.close,
                            children: "Назад"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "submit",
                            disabled: submit.loading,
                            children: !submit.loading ? "Добавить" : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_dots/* LoadingDots */.x, {
                                size: 4,
                                children: "Добавляем"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
CompanyCreateModal.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/lib/use-modal.tsx
var use_modal = __webpack_require__(74363);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/container/menu-container.tsx
var menu_container = __webpack_require__(8581);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/button/menu-button.tsx
var menu_button = __webpack_require__(92422);
;// CONCATENATED MODULE: ./src/shared/ui/icon/switch.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSwitch = function SvgSwitch(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    fill: "none",
    height: 16,
    stroke: "currentColor",
    strokeWidth: 1.5,
    viewBox: "0 0 16 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M13 8.517 8 3 3 8.517m0 6.963 5 5.517 5-5.517"
  })));
};
/* harmony default export */ var icon_switch = (SvgSwitch);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/menu/menu.tsx
var menu = __webpack_require__(78024);
// EXTERNAL MODULE: ./src/shared/ui/menu/lib/menu-button.tsx
var lib_menu_button = __webpack_require__(35625);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/item/menu-item.module.scss
var menu_item_module = __webpack_require__(9993);
var menu_item_module_default = /*#__PURE__*/__webpack_require__.n(menu_item_module);
;// CONCATENATED MODULE: ./src/shared/ui/menu/ui/item/menu-link.tsx






const MenuLink = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib_menu_button/* MenuLink */.Uk, {
        as: (link_default()),
        href: props.href,
        className: classnames_default()((menu_item_module_default()).menu_item, props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            props.prefix && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (menu_item_module_default()).prefix,
                children: props.prefix
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: props.children
            }),
            props.suffix && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (menu_item_module_default()).suffix,
                children: props.suffix
            })
        ]
    });
};
MenuLink.defaultProps = {};

;// CONCATENATED MODULE: ./src/shared/ui/icon/done.svg
var done_path;
function done_extends() { done_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return done_extends.apply(this, arguments); }

var SvgDone = function SvgDone(props) {
  return /*#__PURE__*/react.createElement("svg", done_extends({
    "data-testid": "geist-icon",
    fill: "none",
    height: 20,
    shapeRendering: "geometricPrecision",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    viewBox: "0 0 24 24",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), done_path || (done_path = /*#__PURE__*/react.createElement("path", {
    d: "M20 6 9 17l-5-5"
  })));
};
/* harmony default export */ var done = (SvgDone);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/divider/menu-divider.tsx
var menu_divider = __webpack_require__(99104);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/item/menu-item.tsx
var menu_item = __webpack_require__(38234);
;// CONCATENATED MODULE: ./src/shared/ui/icon/plus-circle.svg
var _circle, plus_circle_path;
function plus_circle_extends() { plus_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return plus_circle_extends.apply(this, arguments); }

var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/react.createElement("svg", plus_circle_extends({
    "data-testid": "geist-icon",
    fill: "none",
    height: 24,
    shapeRendering: "geometricPrecision",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), plus_circle_path || (plus_circle_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 8v8M8 12h8"
  })));
};
/* harmony default export */ var plus_circle = (SvgPlusCircle);
// EXTERNAL MODULE: ./src/modules/layout/ui/company-switcher/company-list/company-list.module.scss
var company_list_module = __webpack_require__(15388);
var company_list_module_default = /*#__PURE__*/__webpack_require__.n(company_list_module);
;// CONCATENATED MODULE: ./src/modules/layout/ui/company-switcher/company-list/company-list.tsx








const CompanyList = (props)=>{
    var _profile_data, _companyList_data;
    const companyList = init/* api.company.useCompanyList */.h.company.useCompanyList();
    const profile = init/* api.userProfile.useUserProfileMe */.h.userProfile.useUserProfileMe();
    const isAdmin = ((_profile_data = profile.data) === null || _profile_data === void 0 ? void 0 : _profile_data.role) === "ADMIN";
    const router = (0,next_router.useRouter)();
    const isAdminRoute = isAdmin && (router.asPath.startsWith("/admin/") || router.asPath === "/admin");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((company_list_module_default()).company_list, props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            isAdmin && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                        href: _router/* default.admin.href */.Z.admin.href,
                        className: classnames_default()((company_list_module_default()).item),
                        suffix: isAdminRoute && /*#__PURE__*/ (0,jsx_runtime.jsx)(done, {}),
                        prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                            id: "",
                            name: "★",
                            size: 24
                        }),
                        children: "Админка"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_divider/* MenuDivider */.R, {})
                ]
            }),
            (_companyList_data = companyList.data) === null || _companyList_data === void 0 ? void 0 : _companyList_data.map((it)=>{
                const active = it.slug === props.value && !isAdminRoute;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item/* MenuItem */.s, {
                    suffix: active && /*#__PURE__*/ (0,jsx_runtime.jsx)(done, {}),
                    onClick: ()=>props.onSelect(it.slug || it.id),
                    className: classnames_default()((company_list_module_default()).item, active && (company_list_module_default()).active),
                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                        id: it.id,
                        name: it.name,
                        image: it.avatarImage,
                        size: 24
                    }),
                    children: it.name
                }, it.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item/* MenuItem */.s, {
                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(plus_circle, {}),
                onClick: props.onCreate,
                children: "Добавить компанию"
            })
        ]
    });
};
CompanyList.defaultProps = {};

// EXTERNAL MODULE: ./src/modules/layout/ui/company-switcher/company-switcher.module.scss
var company_switcher_module = __webpack_require__(55021);
var company_switcher_module_default = /*#__PURE__*/__webpack_require__.n(company_switcher_module);
// EXTERNAL MODULE: ./src/shared/lib/local-storage.ts
var local_storage = __webpack_require__(93118);
;// CONCATENATED MODULE: ./src/shared/lib/use-local-storage.ts


const useLocalStorage = (key, initial)=>{
    const [value, setValue] = (0,react.useState)(()=>local_storage/* LocalStorage.getItem */.m.getItem(key));
    (0,react.useEffect)(()=>{
        let newValue = local_storage/* LocalStorage.getItem */.m.getItem(key);
        if (newValue === undefined) {
            newValue = typeof initial === "function" ? initial() : initial;
        }
        setValue(newValue);
        return local_storage/* LocalStorage.subscribe */.m.subscribe(key, setValue);
    }, [
        key,
        setValue
    ]);
    const onChange = (0,react.useCallback)((valueOrFn)=>{
        const newValue = typeof valueOrFn === "function" ? valueOrFn(local_storage/* LocalStorage.getItem */.m.getItem(key)) : valueOrFn;
        local_storage/* LocalStorage.setItem */.m.setItem(key, newValue);
    }, [
        key
    ]);
    return [
        value,
        onChange
    ];
};

;// CONCATENATED MODULE: ./src/modules/layout/ui/company-switcher/lib/company-slug.ts





const useCompanySlug = ()=>{
    var _companyList_data, _companyList_data_;
    const companyList = init/* api.company.useCompanyList */.h.company.useCompanyList();
    const fromUrl = (0,next_router.useRouter)().query.company;
    const [fromLocalStorage, saveToLocalStorage] = useLocalStorage("current-company");
    const fromApi = (_companyList_data = companyList.data) === null || _companyList_data === void 0 ? void 0 : (_companyList_data_ = _companyList_data[0]) === null || _companyList_data_ === void 0 ? void 0 : _companyList_data_.slug;
    const current = fromUrl || fromLocalStorage || fromApi;
    (0,react.useEffect)(()=>{
        if (current && current !== fromLocalStorage) {
            saveToLocalStorage(current);
        }
    }, [
        current,
        fromLocalStorage,
        saveToLocalStorage
    ]);
    const onChange = (slug)=>{
        if (fromUrl) {
            router_default().replace({
                query: {
                    ...(router_default()).query,
                    company: slug
                }
            });
            return;
        } else {
            router_default().push(_router/* default.company */.Z.company(slug).href);
        }
    };
    return [
        current,
        onChange
    ];
};

;// CONCATENATED MODULE: ./src/modules/layout/ui/company-switcher/company-switcher.tsx













const CompanySwitcher = (props)=>{
    var _profile_data;
    const [slug, setSlug] = useCompanySlug();
    const { data: company  } = init/* api.company.useCompanyGet */.h.company.useCompanyGet(slug);
    const profile = init/* api.userProfile.useUserProfileMe */.h.userProfile.useUserProfileMe();
    const isAdmin = ((_profile_data = profile.data) === null || _profile_data === void 0 ? void 0 : _profile_data.role) === "ADMIN";
    const router = (0,next_router.useRouter)();
    const isAdminRoute = isAdmin && (router.asPath.startsWith("/admin/") || router.asPath === "/admin");
    const onCreate = ()=>{
        use_modal/* Modals.open */.nK.open(CompanyCreateModal, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_container/* MenuContainer */.F, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_button/* MenuButton */.j, {
                variant: "unstyled",
                className: classnames_default()((company_switcher_module_default()).company_switcher, props.className),
                style: props.style,
                id: props.htmlId,
                children: [
                    !isAdminRoute && /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: _router/* default.company */.Z.company(slug).finances.href,
                        className: (company_switcher_module_default()).company,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                                id: company === null || company === void 0 ? void 0 : company.id,
                                name: company === null || company === void 0 ? void 0 : company.name,
                                image: company === null || company === void 0 ? void 0 : company.avatarImage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (company_switcher_module_default()).name,
                                children: company === null || company === void 0 ? void 0 : company.name
                            })
                        ]
                    }),
                    isAdminRoute && /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: _router/* default.admin.href */.Z.admin.href,
                        className: (company_switcher_module_default()).company,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                                id: "",
                                name: "★"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (company_switcher_module_default()).name,
                                children: "Админка"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (company_switcher_module_default()).button,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_switch, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v, {
                arrow: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyList, {
                    value: slug,
                    onCreate: onCreate,
                    onSelect: setSlug
                })
            })
        ]
    });
};
CompanySwitcher.defaultProps = {};

;// CONCATENATED MODULE: ./src/modules/layout/ui/header-dashboard/header-dashboard.tsx










const HeaderDashboard = (props)=>{
    var _profile_data, _profile_data1, _profile_data2, _profile_data3, _profile_data4, _profile_data5;
    const profile = init/* api.userProfile.useUserProfileMe */.h.userProfile.useUserProfileMe();
    const [theme, setTheme] = (0,model_theme/* useTheme */.F)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: classnames_default()((header_dashboard_module_default()).header_dashboard, props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (header_dashboard_module_default()).breadcrumbs,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (header_dashboard_module_default()).logo,
                        children: "control.online"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySwitcher, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (header_dashboard_module_default()).right,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover, {
                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (header_dashboard_module_default()).profile,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (header_dashboard_module_default()).full_name,
                                children: ((_profile_data = profile.data) === null || _profile_data === void 0 ? void 0 : _profile_data.name) || ((_profile_data1 = profile.data) === null || _profile_data1 === void 0 ? void 0 : _profile_data1.email)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                                id: (_profile_data2 = profile.data) === null || _profile_data2 === void 0 ? void 0 : _profile_data2.id,
                                name: ((_profile_data3 = profile.data) === null || _profile_data3 === void 0 ? void 0 : _profile_data3.name) || ((_profile_data4 = profile.data) === null || _profile_data4 === void 0 ? void 0 : _profile_data4.email),
                                image: (_profile_data5 = profile.data) === null || _profile_data5 === void 0 ? void 0 : _profile_data5.avatarImage
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover.Menu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover.Item, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: _router/* default.profile.href */.Z.profile.href,
                                    children: "Настройки"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover.Item, {
                                children: [
                                    "Тема",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* Select */.P, {
                                        size: "small",
                                        value: theme,
                                        onChange: setTheme,
                                        style: {
                                            width: 128,
                                            margin: "-8px 0 -8px 10px"
                                        },
                                        options: [
                                            {
                                                value: undefined,
                                                label: "Системная"
                                            },
                                            {
                                                value: "dark",
                                                label: "Темная"
                                            },
                                            {
                                                value: "light",
                                                label: "Светлая"
                                            }
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover.Item, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: _router/* default.logout.href */.Z.logout.href,
                                    children: "Выйти"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
HeaderDashboard.defaultProps = {};


/***/ }),

/***/ 35629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ HeaderTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53865);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57711);
/* harmony import */ var _header_title_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27263);
/* harmony import */ var _header_title_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_header_title_module_scss__WEBPACK_IMPORTED_MODULE_4__);







const HeaderTitle = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_header_title_module_scss__WEBPACK_IMPORTED_MODULE_4___default().header_title), props.back && (_header_title_module_scss__WEBPACK_IMPORTED_MODULE_4___default().with_back), props.className),
        style: props.style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_container__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W, {
            fullWidth: props.fullWidth,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_header_title_module_scss__WEBPACK_IMPORTED_MODULE_4___default().inner),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_header_title_module_scss__WEBPACK_IMPORTED_MODULE_4___default().main),
                        children: [
                            props.back && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: props.back.href,
                                className: (_header_title_module_scss__WEBPACK_IMPORTED_MODULE_4___default().back),
                                children: [
                                    props.back.title,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_header_title_module_scss__WEBPACK_IMPORTED_MODULE_4___default().back_icon),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            stroke: 1.5,
                                            size: 20
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                children: props.children
                            })
                        ]
                    }),
                    props.actions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_header_title_module_scss__WEBPACK_IMPORTED_MODULE_4___default().actions),
                        children: props.actions
                    })
                ]
            })
        })
    });
};
HeaderTitle.defaultProps = {};


/***/ }),

/***/ 2629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ capitalize; }
/* harmony export */ });
const capitalize = (value)=>{
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
};


/***/ }),

/***/ 28455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getErrorMessage; }
/* harmony export */ });
/* harmony import */ var shared_lib_capitalize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2629);

const getErrorMessage = async (e)=>{
    if (e instanceof Response) {
        try {
            const json = await e.json();
            if (typeof json !== "object" || typeof json.message !== "string") {
                console.error(json);
                throw new Error();
            }
            const type = typeof json.type === "string" ? json.type : "custom";
            let message = (0,shared_lib_capitalize__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .k)(json.message);
            if (!message.endsWith(".")) {
                message += ".";
            }
            return {
                type,
                message
            };
        } catch (ignore) {
            return {
                type: "custom",
                message: e.statusText
            };
        }
    } else if (e instanceof Error) {
        return {
            type: "custom",
            message: e.message
        };
    } else {
        return {
            type: "custom",
            message: "Неизвестная ошибка. Попробуйте еще раз, если не получится — обратитесь в поддержку."
        };
    }
};


/***/ }),

/***/ 24453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useApiMethod; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var shared_lib_error_message__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28455);


const useApiMethod = (method, onSuccess)=>{
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const call = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (loading) throw new Error("Method is loading");
        setLoading(true);
        try {
            // @ts-ignore
            const resp = await method(...args);
            setError(undefined);
            await (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(resp));
            return resp;
        } catch (e) {
            const err = await (0,shared_lib_error_message__WEBPACK_IMPORTED_MODULE_1__/* .getErrorMessage */ .e)(e);
            setError(err);
            throw e;
        } finally{
            setLoading(false);
        }
    }, [
        method,
        setLoading,
        setError
    ]);
    return {
        call,
        loading,
        error,
        setError
    };
};


/***/ }),

/***/ 57233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ Avatar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _avatar_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26035);
/* harmony import */ var _avatar_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_avatar_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);





const Avatar = (props)=>{
    const style = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>({
            ...props.style,
            "--avatar-size": "".concat(props.size, "px")
        }), [
        props.style,
        props.size
    ]);
    if (!props.image) {
        var _props_name, _props_name_;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_avatar_module_scss__WEBPACK_IMPORTED_MODULE_4___default().avatar), props.className),
            style: style,
            id: props.htmlId,
            children: (_props_name = props.name) === null || _props_name === void 0 ? void 0 : (_props_name_ = _props_name[0]) === null || _props_name_ === void 0 ? void 0 : _props_name_.toUpperCase()
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_avatar_module_scss__WEBPACK_IMPORTED_MODULE_4___default().avatar), props.className),
        style: style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
            src: props.image.url,
            alt: props.name,
            width: props.size - 2,
            height: props.size - 2
        })
    });
};
Avatar.defaultProps = {
    size: 32
};


/***/ }),

/***/ 64871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ Error; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _error_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95811);
/* harmony import */ var _error_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_error_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Error = (props)=>{
    var _props_label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().error), props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            props.label !== null && props.label !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                children: [
                    (_props_label = props.label) !== null && _props_label !== void 0 ? _props_label : "Ошибка",
                    ": "
                ]
            }),
            props.children
        ]
    });
};
Error.defaultProps = {};


/***/ }),

/***/ 99104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MenuDivider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _menu_divider_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1827);
/* harmony import */ var _menu_divider_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_menu_divider_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const MenuDivider = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_menu_divider_module_scss__WEBPACK_IMPORTED_MODULE_3___default().menu_divider), props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
MenuDivider.defaultProps = {};


/***/ }),

/***/ 4629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/lib/use-key-down.tsx
var use_key_down = __webpack_require__(55353);
// EXTERNAL MODULE: ./src/shared/lib/router.ts
var router = __webpack_require__(18874);
// EXTERNAL MODULE: ./src/shared/lib/use-handle-resize.ts
var use_handle_resize = __webpack_require__(41176);
// EXTERNAL MODULE: ./src/shared/ui/drawer/drawer.tsx
var drawer = __webpack_require__(6547);
// EXTERNAL MODULE: ./src/shared/ui/modal/action/modal-action.module.scss
var modal_action_module = __webpack_require__(91950);
var modal_action_module_default = /*#__PURE__*/__webpack_require__.n(modal_action_module);
;// CONCATENATED MODULE: ./src/shared/ui/modal/action/modal-action.tsx




const ModalAction = (param)=>{
    let { htmlType , className , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: classnames_default()((modal_action_module_default()).modal_action, className),
        ...props,
        type: htmlType
    });
};
ModalAction.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/modal/actions/modal-actions.module.scss
var modal_actions_module = __webpack_require__(18694);
var modal_actions_module_default = /*#__PURE__*/__webpack_require__.n(modal_actions_module);
;// CONCATENATED MODULE: ./src/shared/ui/modal/actions/modal-actions.tsx




const ModalActions = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: classnames_default()((modal_actions_module_default()).modal_actions, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
ModalActions.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/modal/body/modal-body.module.scss
var modal_body_module = __webpack_require__(52631);
var modal_body_module_default = /*#__PURE__*/__webpack_require__.n(modal_body_module);
;// CONCATENATED MODULE: ./src/shared/ui/modal/body/modal-body.tsx




const ModalBody = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((modal_body_module_default()).modal_body, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
ModalBody.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/modal/form-item/modal-form-item.module.scss
var modal_form_item_module = __webpack_require__(91467);
var modal_form_item_module_default = /*#__PURE__*/__webpack_require__.n(modal_form_item_module);
;// CONCATENATED MODULE: ./src/shared/ui/modal/form-item/modal-form-item.tsx




const ModalFormItem = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((modal_form_item_module_default()).modal_form_item, props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (modal_form_item_module_default()).label,
                children: props.label
            }),
            props.children
        ]
    });
};
ModalFormItem.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/modal/header/modal-header.module.scss
var modal_header_module = __webpack_require__(37173);
var modal_header_module_default = /*#__PURE__*/__webpack_require__.n(modal_header_module);
;// CONCATENATED MODULE: ./src/shared/ui/modal/header/modal-header.tsx




const ModalHeader = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((modal_header_module_default()).modal_header, props.border && (modal_header_module_default()).border, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
ModalHeader.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/modal/modal.module.scss
var modal_module = __webpack_require__(67921);
var modal_module_default = /*#__PURE__*/__webpack_require__.n(modal_module);
// EXTERNAL MODULE: ./src/shared/ui/modal/subtitle/modal-subtitle.module.scss
var modal_subtitle_module = __webpack_require__(73799);
var modal_subtitle_module_default = /*#__PURE__*/__webpack_require__.n(modal_subtitle_module);
;// CONCATENATED MODULE: ./src/shared/ui/modal/subtitle/modal-subtitle.tsx




const ModalSubtitle = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: classnames_default()((modal_subtitle_module_default()).modal_subtitle, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
ModalSubtitle.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/modal/title/modal-title.module.scss
var modal_title_module = __webpack_require__(70611);
var modal_title_module_default = /*#__PURE__*/__webpack_require__.n(modal_title_module);
;// CONCATENATED MODULE: ./src/shared/ui/modal/title/modal-title.tsx




const ModalTitle = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
        className: classnames_default()((modal_title_module_default()).modal_title, props.left && (modal_title_module_default()).left, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
ModalTitle.defaultProps = {};

;// CONCATENATED MODULE: ./src/shared/ui/modal/modal.tsx














const Modal = (props)=>{
    const modalRef = (0,react.useRef)(null);
    const onClose = (0,react.useCallback)(()=>{
        var _props_onClose;
        return (_props_onClose = props.onClose) === null || _props_onClose === void 0 ? void 0 : _props_onClose.call(props);
    }, [
        props.onClose
    ]);
    (0,use_key_down/* useKeyDown */.K)(use_key_down/* KeyName.ESC */.e.ESC, onClose);
    (0,router/* useRouterChange */.l)(onClose, [
        onClose
    ]);
    const width = (0,use_handle_resize/* useHandleResize */.s)();
    if (width === 0) return null;
    if (width >= 600) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((modal_module_default()).modal, props.className),
        style: props.style,
        id: props.htmlId,
        onMouseDown: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (modal_module_default()).wrapper,
            style: {
                width: props.width
            },
            onMouseDown: (e)=>e.stopPropagation(),
            children: props.children
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(drawer/* Drawer */.d, {
        onDismiss: onClose,
        show: width < 600,
        children: props.children
    });
};
Modal.defaultProps = {};
Modal.Action = ModalAction;
Modal.Actions = ModalActions;
Modal.Body = ModalBody;
Modal.Header = ModalHeader;
Modal.Subtitle = ModalSubtitle;
Modal.Title = ModalTitle;
Modal.FormItem = ModalFormItem;


/***/ }),

/***/ 14080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83083);
/* harmony import */ var _select_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49186);
/* harmony import */ var _select_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_select_module_scss__WEBPACK_IMPORTED_MODULE_3__);





const PLACEHOLDER_VALUE = "$__PLACEHOLDER__$";
const Select = (param)=>{
    let { value , onChange , options , size , className , label , readOnly , allowEmpty , placeholder , ...props } = param;
    const hasUndefinedOption = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        return options === null || options === void 0 ? void 0 : options.map((it)=>"options" in it ? it.options || [] : [
                it
            ]).flat().find((it)=>it.value === undefined);
    }, [
        options
    ]);
    const onChangeHandler = (e)=>{
        if (e.target.value === PLACEHOLDER_VALUE) {
            if (allowEmpty) {
                onChange === null || onChange === void 0 ? void 0 : onChange(undefined);
            }
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_select_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container), className),
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_select_module_scss__WEBPACK_IMPORTED_MODULE_3___default().label),
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_select_module_scss__WEBPACK_IMPORTED_MODULE_3___default().select), size === "small" && (_select_module_scss__WEBPACK_IMPORTED_MODULE_3___default().small), size === "medium" && (_select_module_scss__WEBPACK_IMPORTED_MODULE_3___default().medium), size === "large" && (_select_module_scss__WEBPACK_IMPORTED_MODULE_3___default().large), readOnly && (_select_module_scss__WEBPACK_IMPORTED_MODULE_3___default().read_only), value === undefined && (_select_module_scss__WEBPACK_IMPORTED_MODULE_3___default().empty)),
                ...props,
                onChange: onChangeHandler,
                children: [
                    value === undefined && !hasUndefinedOption && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                        value: PLACEHOLDER_VALUE,
                        selected: true,
                        children: placeholder
                    }),
                    !!value && allowEmpty && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                        value: PLACEHOLDER_VALUE,
                        selected: true,
                        children: placeholder
                    }),
                    options === null || options === void 0 ? void 0 : options.map((it)=>{
                        if ("options" in it) {
                            var _it_options;
                            // OptionGroup
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("optgroup", {
                                label: it.label,
                                children: (_it_options = it.options) === null || _it_options === void 0 ? void 0 : _it_options.map((it)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: it.value,
                                        selected: value === it.value,
                                        children: it.label
                                    }, it.value))
                            }, it.key);
                        } else {
                            // Option
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                value: it.value,
                                disabled: it.disabled,
                                selected: value === it.value,
                                children: it.label
                            }, it.value);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_select_module_scss__WEBPACK_IMPORTED_MODULE_3___default().suffix),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
            })
        ]
    });
};
Select.defaultProps = {};


/***/ }),

/***/ 15388:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"company-list_item__Gqp_P","icon":"company-list_icon___4aLM","active":"company-list_active__dHJIY","name":"company-list_name__mt0NA"};

/***/ }),

/***/ 55021:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"company_switcher":"company-switcher_company_switcher__Em0eo","company":"company-switcher_company__gs_xH","name":"company-switcher_name__FfmAv","button":"company-switcher_button__bvG8b","overlay":"company-switcher_overlay__aoG4L","menu":"company-switcher_menu__BXLLH","scope_open__O6KtU":"company-switcher_scope_open__O6KtU__z5uzn"};

/***/ }),

/***/ 20798:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"container_container__fOSV7","full_width":"container_full_width__9PScV"};

/***/ }),

/***/ 78593:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header_dashboard":"header-dashboard_header_dashboard__kb_VA","breadcrumbs":"header-dashboard_breadcrumbs__Fdu0o","logo":"header-dashboard_logo__1frgO","right":"header-dashboard_right__Cqdc0","profile":"header-dashboard_profile__IZCEC","full_name":"header-dashboard_full_name__jJnTF"};

/***/ }),

/***/ 27263:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header_title":"header-title_header_title__e62Rj","inner":"header-title_inner__1kWjh","main":"header-title_main__x3B5B","back":"header-title_back__DtdK0","back_icon":"header-title_back_icon__H4svh","with_back":"header-title_with_back__Q3uRV","actions":"header-title_actions__vrktB"};

/***/ }),

/***/ 26035:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__e_jds"};

/***/ }),

/***/ 95811:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error":"error_error__VtAWS"};

/***/ }),

/***/ 1827:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menu_divider":"menu-divider_menu_divider__Ai5nF"};

/***/ }),

/***/ 91950:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal_action":"modal-action_modal_action__rk7qA"};

/***/ }),

/***/ 18694:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal_actions":"modal-actions_modal_actions__lHoF9"};

/***/ }),

/***/ 52631:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal_body":"modal-body_modal_body__LZcJe"};

/***/ }),

/***/ 91467:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal_form_item":"modal-form-item_modal_form_item__5m30v","label":"modal-form-item_label__wgMCK"};

/***/ }),

/***/ 37173:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal_header":"modal-header_modal_header__tMvQA","border":"modal-header_border__swJKq"};

/***/ }),

/***/ 67921:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__OC8iZ","wrapper":"modal_wrapper__W0gqo","init":"modal_init__WQn4J"};

/***/ }),

/***/ 73799:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal_subtitle":"modal-subtitle_modal_subtitle__rV_Wi"};

/***/ }),

/***/ 70611:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"modal-title_modal_title__3xkHs","left":"modal-title_left__5ctjc"};

/***/ }),

/***/ 67053:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 13418:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"popover_item":"popover-item_popover_item__50SiM","active":"popover-item_active__aCWgE"};

/***/ }),

/***/ 99040:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"popover_menu":"popover-menu_popover_menu__ggVVC"};

/***/ }),

/***/ 55837:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"popover":"popover_popover__GnZNk","open":"popover_open__lGiHE","trigger":"popover_trigger__1G2mZ","overlay":"popover_overlay__Cnse_","inner":"popover_inner__ZkbYb"};

/***/ }),

/***/ 49186:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"select_container__eIhkY","select":"select_select__094LK","read_only":"select_read_only__snJuq","empty":"select_empty__C0emE","small":"select_small__PTi_X","medium":"select_medium__hm_rH","large":"select_large__RdlZA","prefix":"select_prefix__XtarP","suffix":"select_suffix__ErEdK","label":"select_label__6bQXk","empty_option":"select_empty_option__zAIDX"};

/***/ })

}]);